/// <reference types="@types/googlemaps" />
import { AfterViewInit, Inject, Component, EventEmitter, OnDestroy, Output, ViewChild, ViewEncapsulation, Renderer2 } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, PopupRequest, RedirectRequest, EventMessage, EventType } from '@azure/msal-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { filter, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserIdleService } from 'angular-user-idle';
import { Observable,throwError } from 'rxjs';
import { datadogRum } from '@datadog/browser-rum';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class AppComponent {
  authtoken;
  isUserLoggedIn: boolean = false;
  userName?: string = '';
  token;
  sessiontimeout: number;
  flag = 0;
  @ViewChild("SessionAlert") public SessionALert;
  @ViewChild("SessionExpired") public SessionExpired;

  private readonly _destroy = new Subject<void>();
  constructor(@Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private msalBroadCastService: MsalBroadcastService,
    private authService: MsalService, private userIdle: UserIdleService,
    private modalService: NgbModal,
    private renderer: Renderer2
    //  private azureAdDemoSerice:AzureAdDemoService
  ) {

  }
  onFocus(): void {

    // this.isUserLoggedIn = this.authService.instance.getAllAccounts().length > 0;
    // if(this.shouldExecuteMethod)
    // {

    if (!this.isUserLoggedIn) {
      // this.authService.logout();
      // }
    }


  }
  ngOnInit(){
    //start setting dynamic environment
      const envValue:any = environment.production;  // Access your environment value
      const metaTag = this.renderer.createElement('meta');
      this.renderer.setAttribute(metaTag, 'name', 'envProperty');
      this.renderer.setAttribute(metaTag, 'content', envValue);
      this.renderer.appendChild(document.head, metaTag);
    //End setting dynamic environment 
    if(envValue){
      datadogRum.init({
        applicationId: 'b5c6e480-e398-4b94-8a20-a7d0291b1cd1',
        clientToken: 'pub0157bf18cd2761d15455444cfbbd7cc7',
        // site refers to the Datadog site parameter of your organization
        // see https://docs.datadoghq.com/getting_started/site/
        site: 'datadoghq.com',
        service: 'fortwayne-agentportal-staging',
        env: 'staging',
        // Specify a version number to identify the deployed version of your application in Datadog
        // version: '1.0.0',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'allow',
    });
   }
// this.onFocus()

    // this.token= sessionStorage.getItem("ea05eac0-4aa1-4a72-b152-33afe37e7038-b2c_1_sigin_v2.8131dd58-e962-4599-9d5a-bc444d31b399-smartchstsme.b2clogin.com-idtoken-5bdae234-2695-4d50-bea9-6d99db6f6b56----")

    // if(!this.token)
    // {
    //   this.authService.loginRedirect();
    // }
    // this.authService.handleRedirectObservable()
    // .then(res=>{
    //  // console.log(res)
    // })
    // .catch(err => {
    //   console.error(err);
    // });
    // Start watching for user inactivity.
    this.userIdle.startWatching();

    // Start watching when user idle is starting.
    this.sessiontimeout = this.userIdle.getConfigValue().timeout;
    this.userIdle.onTimerStart().subscribe(c => {
     // console.log(c)
      if (this.flag == 0) {
        this.onSessionAlertModal();
        this.flag = 1;
      }
      --this.sessiontimeout;
    });
    //start watch when time is up.
    this.userIdle.onTimeout().subscribe(() => this.logout());

    // this.authService.instance.enableAccountStorageEvents(); // Optional - This will enable ACCOUNT_ADDED and ACCOUNT_REMOVED events emitted when a user logs in or out of another tab or window

    this.msalBroadCastService.msalSubject$

      .pipe(

        filter((msg: EventMessage) => msg.eventType === EventType.ACCOUNT_ADDED || msg.eventType === EventType.ACCOUNT_REMOVED),

      )

      .subscribe((result: EventMessage) => {

       // console.log("result", result)
        if (this.authService.instance.getAllAccounts().length === 0) {

          window.location.pathname = "/";


        } else {

          // this.setLoginDisplay();
         // console.log("else")

        }

      });

    //// console.log("first component");

    this.msalBroadCastService.inProgress$
      // .pipe
      // (filter((interactionStatus:InteractionStatus)=>
      // interactionStatus==InteractionStatus.None),
      // takeUntil(this._destroy))
      .subscribe((x: any) => {
        //// console.log("test",x);

        this.isUserLoggedIn = this.authService.instance.getAllAccounts().length > 0;
        //// console.log(this.isUserLoggedIn);

        if (this.isUserLoggedIn) {

          //datadogRum.startSessionReplayRecording();

          //// console.log("login success");
          // window.alert("loggedin")
          this.userName = this.authService.instance.getAllAccounts()[0].name;
          //// console.log(this.userName);
          //// console.log(x.get)
          // alert(JSON.stringify(this.authService.instance.getTokenCache()))
          //// console.log(this.authService.instance.acquireTokenSilent(x))
          //// console.log(this.authService.instance.acquireTokenByCode(x))
          //// console.log(this.authService.instance.acquireTokenPopup(x))

        }
        // this.azureAdDemoSerice.isUserLoggedIn.next(this.isUserLoggedIn);
      })
  }
  setLoginDisplay() {
    // this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;

  }
  ngOnDestroy(): void {
    this._destroy.next(undefined);
    this._destroy.complete();
  }
  login() {
    // if (this.msalGuardConfig.authRequest) {
    //   this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest)
    // }
    // else {
    //   this.authService.loginRedirect();
    // }
  }
  // logout()
  // {
  //   this.authService.logoutRedirect({postLogoutRedirectUri:environment.JavaUrlEndPoint});
  // }

  stop() {
    this.userIdle.stopTimer();
  }

  stopWatching() {
    this.userIdle.stopWatching();
  }

  startWatching() {
    this.userIdle.startWatching();
  }

  restart() {
    this.userIdle.resetTimer();
  }
  onSessionAlertModal() {
    this.modalService.open(this.SessionALert);
  }
  logout() {
    localStorage.clear();
    sessionStorage.clear();
    this.authService.logout();
  }
  close() {
    // window.alert("in close")
    window.location.reload();
  }

}
